/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActivityChannelOrientationConfiguration } from './activityChannelOrientationConfiguration';
import { ShareDto } from './shareDto';
import { ParameterData } from './parameterData';
import { RequestedShare } from './requestedShare';


export interface DropOffExtendedDto { 
    id?: number;
    label?: string;
    role?: DropOffExtendedDto.RoleEnum;
    shares?: Array<ShareDto>;
    requestedShares?: Array<RequestedShare>;
    name: string;
    description?: string;
    deviceTypeId?: string;
    deviceTypeCustomerName?: string;
    deviceTypeActivityChannelOrientations?: ActivityChannelOrientationConfiguration;
    parameterDataList?: Array<ParameterData>;
    firmwareVersionId?: string;
    bootloaderVersionId?: string;
    updateTs?: string;
    pcbTypeId?: string;
    nfcTagUid?: string;
    collarId?: number;
    type?: DropOffExtendedDto.TypeEnum;
    radioFiring?: boolean;
    releaseTime?: number;
    releaseTimeMode?: DropOffExtendedDto.ReleaseTimeModeEnum;
}
export namespace DropOffExtendedDto {
    export const RoleEnum = {
        Reader: 'READER',
        DataManager: 'DATA_MANAGER',
        Owner: 'OWNER',
        DeviceManager: 'DEVICE_MANAGER'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
    export const TypeEnum = {
        Internal: 'INTERNAL',
        External: 'EXTERNAL'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
    export const ReleaseTimeModeEnum = {
        Absolute: 'ABSOLUTE',
        Relative: 'RELATIVE'
    } as const;
    export type ReleaseTimeModeEnum = typeof ReleaseTimeModeEnum[keyof typeof ReleaseTimeModeEnum];
}


export type TypeEnum = typeof DropOffExtendedDto.TypeEnum[keyof typeof DropOffExtendedDto.TypeEnum];
export type ReleaseTimeModeEnum = typeof DropOffExtendedDto.ReleaseTimeModeEnum[keyof typeof DropOffExtendedDto.ReleaseTimeModeEnum];
